import type { CaseFile } from '@/modules/Cases/types'
import { useCaseSidebarNavigation } from '@/modules/Cases/useCaseSidebarNavigation'
import { ref } from 'vue'

const selectedFile = ref<CaseFile | null>(null)

export function useCaseFilePreview() {
  const { openSidebar, isSidebarOpen } = useCaseSidebarNavigation()

  const openFilePreview = (file: CaseFile) => {
    selectedFile.value = file
    openSidebar()
  }

  const closeFilePreview = () => {
    selectedFile.value = null
  }

  const isFilePreviewOpen = () => {
    return selectedFile.value !== null && isSidebarOpen.value
  }

  return {
    selectedFile,
    openFilePreview,
    closeFilePreview,
    isFilePreviewOpen,
  }
}
